import instance from "../utils/request.js"
import { getRequest } from "../utils/request.js"

/*获取生产订单信息*/
export function GetCheckdelivery(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/checkdelivery/",
        params:data
    })
}

/*获取生产订单供应商信息*/
export function SupplierInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/optionssupplier/",
        params:data
    })
}

/*勾选订单发货*/
export function Checkdelivery(data = {}){
return instance.request({
        method: "post",
        url: "ordermanage/checkdeliveryHandle/",
        data:data,
    })
}
